import { render, staticRenderFns } from "./ReportViewAdendasJugadores.vue?vue&type=template&id=112e61b4&scoped=true&"
import script from "./ReportViewAdendasJugadores.vue?vue&type=script&lang=js&"
export * from "./ReportViewAdendasJugadores.vue?vue&type=script&lang=js&"
import style0 from "./ReportViewAdendasJugadores.vue?vue&type=style&index=0&id=112e61b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112e61b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
  VTooltip,
})
